import React, { Component } from 'react';
//import '../Main.css';
import '../App.css';
import Header from './Header';
import Main, { authentication } from './Main';
import { loadTranslations } from '../misc/i18n';
import {
  QueryClient,
  QueryClientProvider,
} from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

const queryClient = new QueryClient()

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHeaderMenu: true,
      translationLoaded: false,
      sessionLoaded: false
    };
    this.handleShowHeaderMenu = this.handleShowHeaderMenu.bind(this);
  }
  handleShowHeaderMenu(show) {
    this.setState({ showHeaderMenu: show })
  }

  componentDidMount() {
    let that = this;
    loadTranslations(result => {
      that.setState({ translationLoaded: true });
    })
    authentication.authenticate(session => this.setState({ session: session, sessionLoaded: true }));
  }
  render() {

    return (
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <div className="App-container">
          {this.state.translationLoaded && this.state.sessionLoaded ?
            <div>
              <Header showMenu={this.state.showHeaderMenu} session={this.state.session} />
              <Main handleShowHeaderMenu={this.handleShowHeaderMenu} session={this.state.session} />
            </div>
            :
            <div></div>
          }
        </div>
      </QueryClientProvider>
    );
  }
}

export default App;
